import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
    id="Vrstva_1"
    className={classes.svg}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 464.6 464.6"
  >
    <style>{".st0{fill:#f03741}.st1{fill:#ffffff}"}</style>
    <path
      className="st0"
      d="M176.4 310.5c-66.9-28.6-97.9-106-69.2-172.9 28.4-66.4 105-97.5 171.7-69.7"
    />
    <path
      className="st1"
      d="M289.4 154.9c67.1 28 98.9 105.1 70.9 172.2S255.2 426 188.1 398c-.4-.2-.8-.3-1.2-.5"
    />
    <path className="st0" d="M73.1 342.7h65.5v65.5H73.1z" />
    <circle className="st1" cx={360.3} cy={90.2} r={32.8} />
  </svg>  
  );
};

export default LogoIcon;
